import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
  .set('Search', new Immutable.List([]))
  .set('Response', new Immutable.Map({}))
  .set('Get', new Immutable.Map({}))

/* Types */
export const ACTION_GET_TYPECATALOG = 'ACTION_GET_TYPECATALOG'
export const ACTION_SEARCH_TYPECATALOG = 'ACTION_SEARCH_TYPECATALOG'
export const ACTION_DELETE_TYPECATALOG = 'ACTION_DELETE_TYPECATALOG'
export const ACTION_UPDATE_TYPECATALOG = 'ACTION_UPDATE_TYPECATALOG'

/* Reducer */
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_GET_TYPECATALOG:
      return state.set('Get', new Immutable.Map(action.Obj))
    case ACTION_SEARCH_TYPECATALOG:
      return state.set('Search', new Immutable.List(action.Obj))
    case ACTION_DELETE_TYPECATALOG:
      return state.set('Response', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_TYPECATALOG:
      return state.set('Response', new Immutable.Map(action.Obj))
    default:
      return state
  }
}

/* Action Creators */

export const getTypeCatalog = (id) => {
  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getTypeCatalog',
      method: "POST",
      data: { id },
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_TYPECATALOG, Obj: response.data })
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const addTypeCatalog = (form) => {

  let temp = {
    aplica: {
      id: form.aplica
    },
    autor: sessionStorage.uid,
    deleted: form.state === 1 ? false : true,
    descripcion: form.tipoCatalogo
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/addTypeCatalog',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(() => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.successMessage()))
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const searchTypeCatalog = (form) => {

  Utils.clearNullAndEmpty(form)

  let temp = {
    aplica: {
      id: form.aplica ? form.aplica : null
    },
    deleted: form.state === 1 ? false : form.state === 2 ? true : null,
    descripcion: form.tipoCatalogo ? form.tipoCatalogo : null
  }

  return (dispatch) => {

    dispatch(isLoading(true))
    // service: Object.keys(form).length == 0 ? 'api/searchTypeCatalog' : 'api/searchParamTypeCatalog',

    return new ClientHttpRequest({
      service: 'api/searchTypeCatalog',
      method: "POST",
      data: { ...temp },
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_SEARCH_TYPECATALOG, Obj: response.data })
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }

}

export const deleteTypeCatalog = id => {
  return dispatch => {
    dispatch(isLoading(true))
    dispatch({ type: ACTION_GET_TYPECATALOG, Obj: {} })

    return new ClientHttpRequest({
      service: 'api/deleteTypeCatalog',
      method: 'POST',
      data: { id },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_DELETE_TYPECATALOG, Obj: response.data })
        dispatch(createModal(Utils.successMessage()))
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateTypeCatalog = (form) => {

  let temp = {
    aplica: {
      id: form.aplica
    },
    autor: sessionStorage.uid,
    deleted: form.state === 1 ? false : form.state === 2 ? true : null,
    descripcion: form.tipoCatalogo,
    id: form.id
  }

  return dispatch => {
    dispatch(isLoading(true))
    dispatch({ type: ACTION_GET_TYPECATALOG, Obj: {} })

    return new ClientHttpRequest({
      service: 'api/updateTypeCatalog',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_TYPECATALOG, Obj: response.data })
        dispatch(createModal(Utils.successMessage()))
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const clearTypeCatalog = () => {
  return dispatch => {
    dispatch({ type: ACTION_GET_TYPECATALOG, Obj: {} })
    dispatch({ type: ACTION_SEARCH_TYPECATALOG, Obj: [] })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Catalogs/TypeCatalog/TypeCatalog.js